// game-manager.js
export class GameManager {
    constructor() {
        this.iframe = null;
        this.isGameActive = false;
    }

    // Initialize with iframe reference
    init(iframe) {
        this.iframe = iframe;

        if (iframe) {
            // Set proper sandbox permissions
            iframe.sandbox = 'allow-scripts allow-same-origin allow-popups allow-forms allow-modals allow-pointer-lock allow-orientation-lock';
            iframe.referrerPolicy = 'no-referrer-when-downgrade';

            // Remove allowfullscreen attribute and use allow instead
            iframe.removeAttribute('allowfullscreen');
            iframe.allow = 'autoplay; fullscreen; gamepad; microphone; camera; display-capture';

            this.iframe = iframe;
        }
    }

    // Pause game when not visible
    pauseGame() {
        if (this.iframe && this.iframe.contentWindow) {
            try {
                this.iframe.contentWindow.postMessage({
                    action: 'pause'
                }, '*');
            } catch (e) {
                // If we can't communicate, reduce visibility
                if (this.iframe) {
                    this.iframe.style.opacity = '0.5';
                    this.iframe.style.pointerEvents = 'none';
                }
            }
        }
    }

    // Resume game
    resumeGame() {
        if (this.iframe) {
            this.iframe.style.opacity = '1';
            this.iframe.style.pointerEvents = 'auto';
            try {
                this.iframe.contentWindow.postMessage({
                    action: 'resume'
                }, '*');
            } catch (e) {
                // Game doesn't support messaging - that's okay
                console.log('Game resume message not supported');
            }
        }
    }

    // Clean up
    destroy() {
        if (this.iframe) {
            if (document.fullscreenElement) {
                document.exitFullscreen();
            }

            // Exit iOS fullscreen
            if (this.iframe.classList.contains("ios-fullscreen")) {
                this.iframe.classList.remove("ios-fullscreen");
            }

            this.iframe = null;
        }
        this.isGameActive = false;
    }

    // Toggle fullscreen
    toggleFullscreen() {
        if (!this.iframe) return;

        if (document.fullscreenElement) {
            document.exitFullscreen();
        } else {
            this.iframe.requestFullscreen();
        }
    }
}